export default
{
    MetaposeAPI: {
        BaseURL:                    'https://uxcrd9tnsd.execute-api.us-east-1.amazonaws.com/Production',
//        BaseURL:                    'http://localhost:3000',
        Version:                    '/v1',
        ProviderSignup:             '/provider/signup',
        ProviderSignin:             '/provider/signin',
        ProviderSignout:            '/provider/signout',
        ProviderConfirm:            '/provider/confirm',
        ProviderForgotPassword:     '/provider/forgotpassword',
        ProviderConfirmPassword:    '/provider/confirmpassword',
        ProviderResendConfirmation: '/provider/resendconfirmation',
        PatientSignup:              '/patient/signup',
        PatientSignin:              '/patient/signin',
        PatientSignout:             '/patient/signout',
    }
}



// WEBPACK FOOTER //
// ./src/configuration.js